import { commonjsGlobal as m } from "./index168.js";
import "./index200.js";
import "./index201.js";
import { __exports as n } from "./index202.js";
import { __exports as s } from "./index203.js";
var p = m && m.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
}, u = p(n), i = s;
function r(o, f) {
  var t = {};
  return !o || typeof o != "string" || (0, u.default)(o, function(a, e) {
    a && e && (t[(0, i.camelCase)(a, f)] = e);
  }), t;
}
r.default = r;
var v = r;
export {
  v as c
};
